import { authSagaWatcher } from './containers/Auth/saga';

export const authModuleSaga = [authSagaWatcher];
